import PubSub from "underpub-js";

var UnitInformation = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-UnitInformation',
	};

	$.extend(true, this.options, options);

};

UnitInformation.prototype.init = function() {

	var self = this;

};

export default UnitInformation;
